module.exports = __webpack_public_path__ + "media/39.1fa78ea4.mp3";